import Cookie from 'js-cookie';
export class Logger {
    name;
    level;
    LOGGER_KEY;
    DEBUG_KEY = 'FTO_DEBUG';
    constructor(name, level = 'info') {
        this.LOGGER_KEY = `${this.DEBUG_KEY}_${name.toUpperCase()}`;
        this.name = name;
        this.level = level;
    }
    get isLoggable() {
        return ([Cookie.get(this.LOGGER_KEY), Cookie.get(this.DEBUG_KEY)].indexOf('1') != -1);
    }
    log(message, ...args) {
        if (!this.isLoggable)
            return;
        window.console[this.level](`[${this.name}] ${message}`, ...args);
    }
}
